import React, { useState } from "react";
import Nav from "./Navigation.js";

const LightsOut = () => {
  const [lights, setLights] = useState([
    [false, false, false],
    [false, false, false],
    [false, false, false],
  ]);

  const applyToggle = (grid, row, col) => {
    grid[row][col] = !grid[row][col];
    if (row > 0) grid[row - 1][col] = !grid[row - 1][col];
    if (row < 2) grid[row + 1][col] = !grid[row + 1][col];
    if (col > 0) grid[row][col - 1] = !grid[row][col - 1];
    if (col < 2) grid[row][col + 1] = !grid[row][col + 1];
  };

  const toggleLight = (row, col) => {
    const next = lights.map((r) => [...r]);
    applyToggle(next, row, col);
    setLights(next);
  };

  const newGame = () => {
    const grid = [
      [false, false, false],
      [false, false, false],
      [false, false, false],
    ];
    for (let i = 0; i < 5; i++) {
      applyToggle(grid, Math.floor(Math.random() * 3), Math.floor(Math.random() * 3));
    }
    setLights(grid);
  };

  const won = lights.every((row) => row.every((light) => light));

  return (
    <div className="text-white">
      <Nav />
      <div className="container mx-auto my-8 text-center">
        <h1 className="text-3xl font-bold mb-2">Lights Out Practice</h1>
        <p className="text-gray-400 mb-6">
          Click <span className="text-white font-medium">New Game</span> to randomize a starting board, then click tiles to toggle them and their neighbors. Goal: turn all lights on.
        </p>

        <div className="inline-block bg-gray-800 rounded-xl p-6 shadow-lg">
          <div className="mb-4">
            <button
              className="bg-blue-500 text-white py-2 px-6 rounded hover:bg-blue-600 focus:outline-none transition-colors"
              onClick={newGame}
            >
              New Game
            </button>
          </div>

          <table className="mx-auto">
            <tbody>
              {lights.map((row, rowIndex) => (
                <tr key={rowIndex}>
                  {row.map((light, colIndex) => (
                    <td key={colIndex} className="p-1">
                      <div
                        className={`w-16 h-16 rounded-md border flex items-center justify-center cursor-pointer transition-colors duration-150 ${
                          light
                            ? "bg-yellow-400 border-yellow-300 shadow-md"
                            : "bg-gray-700 border-gray-600 hover:bg-gray-600"
                        }`}
                        onClick={() => toggleLight(rowIndex, colIndex)}
                      >
                        {light && <span className="text-2xl select-none">★</span>}
                      </div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>

          {won && (
            <p className="mt-4 text-green-400 font-bold text-lg">
              ★ All lights on — Puzzle solved! ★
            </p>
          )}
        </div>

        <div className="mt-8 max-w-md mx-auto text-left bg-gray-800 rounded-xl p-5 text-sm text-gray-300">
          <h2 className="text-white font-semibold mb-2">Tips</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Clicking a tile toggles it <em>and</em> its four neighbors (up, down, left, right).</li>
            <li>Order doesn't matter — only whether you click each tile an odd or even number of times.</li>
            <li>Use the Solver tool to get a step-by-step solution if you get stuck.</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default LightsOut;
